import Drawer from './Drawer'
import connect from './connect'

export default connect(Drawer)
